"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperBase = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WrapperBase = _styledComponents["default"].div.withConfig({
  displayName: "WrapperBase",
  componentId: "sc-12io2e-0"
})(["display:flex;flex-direction:", ";justify-content:", ";align-items:", ";width:", ";height:", ";"], function (_ref) {
  var column = _ref.column,
      row = _ref.row;
  return row && 'row' || column && 'column';
}, function (_ref2) {
  var justifyStart = _ref2.justifyStart,
      justifyEnd = _ref2.justifyEnd,
      justifyCenter = _ref2.justifyCenter;
  return justifyStart && 'flex-start' || justifyEnd && 'flex-end' || justifyCenter && 'center';
}, function (_ref3) {
  var alignStart = _ref3.alignStart,
      alignEnd = _ref3.alignEnd,
      alignCenter = _ref3.alignCenter;
  return alignStart && 'flex-start' || alignEnd && 'flex-end' || alignCenter && 'center';
}, function (_ref4) {
  var width = _ref4.width;
  return width || '100%';
}, function (_ref5) {
  var height = _ref5.height;
  return height || '100%';
});

exports.WrapperBase = WrapperBase;